// this is basically RTK internal status, but upper cased
export var RTKQueryState;
(function (RTKQueryState) {
    RTKQueryState["PENDING"] = "PENDING";
    RTKQueryState["REJECTED"] = "REJECTED";
    RTKQueryState["FULFILLED"] = "FULFILLED";
    RTKQueryState["UNINITIALIZED"] = "UNINITIALIZED";
})(RTKQueryState || (RTKQueryState = {}));
